export default "__VITE_ASSET__BD9SqYAj__"